const routes = [
  {
    path: '/company',
    name: 'Company',
    component: () => import(/* webpackChunkName: "company" */ '@/views/company/CompanyMain'),
    meta: {
      layout: 'NoneLayout'
    },
    children: [
      {
        path: 'list',
        alias: '',
        name: 'CompanyList',
        component: () => import(/* webpackChunkName: "company" */ '@/views/company/CompanyList'),
        prop: true,
        meta: {
          step: ['회사 설정', '회사 설정 리스트(company)']
        }
      },
      {
        path: ':seq(\\d+)',
        name: 'CompanyView',
        component: () => import(/* webpackChunkName: "company" */ '@/views/company/CompanyView'),
        prop: true,
        meta: {
          step: ['회사 설정', '회사 설정 세부(company)']
        }
      },
      {
        path: 'write',
        name: 'CompanyWrite',
        component: () => import(/* webpackChunkName: "company" */ '@/views/company/CompanyView'),
        prop: true,
        meta: {
          step: ['회사 설정', '회사 설정 등록(company)']
        }
      }
    ]
  }
]

export default routes
